<template>
  <div style="min-height: 92vh">
    <h3>Servicios</h3>
    <uv-data-table :config="config" :data="global_prod" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Servicios">
      <ServiciosForm :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </ServiciosForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ServiciosForm from "../Servicios/ServiciosForm.vue";
import { mapActions } from "vuex";

export default {
  name: "ServiciosCrud",
  components: {
    modal,
    uvDataTable,
    ServiciosForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      Categories: [],
      editData: [],
      products: [],
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Servicios",
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addServicio",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editServicio",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteServicio",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Codigo",
            value: "Codigo",
          },
          {
            text: "Tipo",
            value: "Tipo",
            canBeFiltered: true,
          },
          {
            text: "Categoria",
            value: "categoria_name",
            canBeFiltered: true,
          },
          {
            text: "Precio",
            value: "Precio",
            format: (row) => {
              return "$" + row["Precio"] + " " + row["Moneda"] + "";
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addServicio") {
        this.formIndex++;
        this.showModal = true;
        this.editMode = false;
        this.editData = {};
      }
      if (buttonId == "editServicio") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "deleteServicio") {
        this.deleteServicio(idSelected[0]);
      }
    },

    successData(data, doAction) {
      data.Precio = parseFloat(data.Precio);
      data.Tipo = "Servicio";
      const targetId =
        data.id ||
        data.Id ||
        (this.editData ? this.editData.id || this.editData.Id : null);
      if (targetId) {
        data.id = targetId;
        data.Id = targetId;
      }
      if (!targetId || doAction === "CREATE") {
        this.saveServicio(data);
      } else {
        this.editServicio(data);
      }
    },
    saveServicio(datos) {
      //datos.Departamento      =  this.MainDepartamento;

      this.$swal({
        title: "¿Deseas agregar este servicio?",
        text: "Los cambios se veran reflejados inmediatamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //'ProShop-Productos-editarProducto'
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-createProducto", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const targetId =
              (result.value.data && result.value.data.id) ||
              (result.value.data &&
              result.value.data.data &&
              typeof result.value.data.data === "object"
                ? result.value.data.data.id
                : null);
            if (targetId) {
              this.$pgsHelper.writeLog({
                Evento: "PRODUCTO_CREATE",
                Mensaje: "Producto creado",
                reference: { id: targetId, tp: "Servicio", al: "Servicio" },
                data: datos
              });
            }
            this.$swal({
              title: "Guardado",
              text: "El servicio se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              //this.getProducts();
            });
          } else {
            this.$swal(
              "Error saving Servicio",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editServicio(datos) {
      //datos.Departamento      =  this.MainDepartamento;

      this.$swal({
        title: "¿Deseas editar este servicio?",
        text: "Los cambios se veran reflejados inmediatamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //'ProShop-Productos-editarProducto'
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-updateProducto", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$pgsHelper.writeLog({
              Evento: "PRODUCTO_EDIT",
              Mensaje: "Producto editado",
              reference: { id: datos.id, tp: "Servicio", al: "Servicio" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El servicio se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              //this.getProducts();
            });
          } else {
            this.$swal(
              "Error saving servicio",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteServicio(id) {
      if (!id) {
        this.$swal("Error", "No se seleccionó ningún servicio para eliminar", "error");
        return;
      }
      const deletedObject = this.getProductoById(id) || { Id: id };
      let datos = { id: id, Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar este servicio?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-deleteProducto", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "PRODUCTO_DELETE",
              Mensaje: "Producto eliminado ",
              reference: { id: id, tp: "Servicio", al: "SERVICIO" },
              data: deletedObject
            });
            this.$swal("El servicio se elimino correctamente", "", "success");
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },

    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      const cats = await this.fetchCategories();
      this.Categories = cats.map((element) => ({
        ...element,
        Nombre: element.label || element.Nombre,
      }));
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },

    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.global_prod, { id: code });
      if (itemIndex >= 0) {
        return this.global_prod[itemIndex];
      }

      return false;
    },
  },
  computed: {
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let servicios = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        if (element.Tipo == "Servicio" && !element.Dlat) {
          servicios.push(element);
        }
      });
      return servicios;
    },
  },
  watch: {},
  mounted() { },
  created() {
    this.getCategories();
    //this.getProducts();
  },
};
</script>
